/**
 * @generated SignedSource<<65b8f92ff5f48547d28cb0907239ba93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_user$data = {
  readonly canRequestShippingQuotePermission: boolean | null;
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user">;
  readonly " $fragmentType": "PdpSharedShippingInfoLink_user";
};
export type PdpSharedShippingInfoLink_user$key = {
  readonly " $data"?: PdpSharedShippingInfoLink_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoLink_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    },
    {
      "alias": "canRequestShippingQuotePermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_REQUEST_SHIPPING_QUOTE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c3f738d67788136e1db4edd3e01dab2f";

export default node;
